// @generated by protoc-gen-es v2.2.3 with parameter "target=js+dts"
// @generated from file patch/go.proto (package go, syntax proto2)
/* eslint-disable */

import { extDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file patch/go.proto.
 */
export const file_patch_go = /*@__PURE__*/
  fileDesc("Cg5wYXRjaC9nby5wcm90bxICZ28iewoHT3B0aW9ucxIMCgRuYW1lGAEgASgJEg0KBWVtYmVkGAIgASgIEgwKBHR5cGUYAyABKAkSDgoGZ2V0dGVyGAogASgJEgwKBHRhZ3MYFCABKAkSEAoIc3RyaW5nZXIYHiABKAkSFQoNc3RyaW5nZXJfbmFtZRgfIAEoCSKEAQoLTGludE9wdGlvbnMSCwoDYWxsGAEgASgIEhAKCG1lc3NhZ2VzGAIgASgIEg4KBmZpZWxkcxgDIAEoCBINCgVlbnVtcxgEIAEoCBIOCgZ2YWx1ZXMYBSABKAgSEgoKZXh0ZW5zaW9ucxgGIAEoCBITCgtpbml0aWFsaXNtcxgKIAMoCTpHCgdtZXNzYWdlEh8uZ29vZ2xlLnByb3RvYnVmLk1lc3NhZ2VPcHRpb25zGNk2IAEoCzILLmdvLk9wdGlvbnNSB21lc3NhZ2U6QQoFZmllbGQSHS5nb29nbGUucHJvdG9idWYuRmllbGRPcHRpb25zGNk2IAEoCzILLmdvLk9wdGlvbnNSBWZpZWxkOkEKBW9uZW9mEh0uZ29vZ2xlLnByb3RvYnVmLk9uZW9mT3B0aW9ucxjZNiABKAsyCy5nby5PcHRpb25zUgVvbmVvZjo+CgRlbnVtEhwuZ29vZ2xlLnByb3RvYnVmLkVudW1PcHRpb25zGNk2IAEoCzILLmdvLk9wdGlvbnNSBGVudW06RQoFdmFsdWUSIS5nb29nbGUucHJvdG9idWYuRW51bVZhbHVlT3B0aW9ucxjZNiABKAsyCy5nby5PcHRpb25zUgV2YWx1ZTpCCgRsaW50EhwuZ29vZ2xlLnByb3RvYnVmLkZpbGVPcHRpb25zGNk2IAEoCzIPLmdvLkxpbnRPcHRpb25zUgRsaW50QidaJWdpdGh1Yi5jb20vYWx0YS9wcm90b3BhdGNoL3BhdGNoL2dvcGI", [file_google_protobuf_descriptor]);

/**
 * Describes the message go.Options.
 * Use `create(OptionsSchema)` to create a new message.
 */
export const OptionsSchema = /*@__PURE__*/
  messageDesc(file_patch_go, 0);

/**
 * Describes the message go.LintOptions.
 * Use `create(LintOptionsSchema)` to create a new message.
 */
export const LintOptionsSchema = /*@__PURE__*/
  messageDesc(file_patch_go, 1);

/**
 * @generated from extension: optional go.Options message = 7001;
 */
export const message = /*@__PURE__*/
  extDesc(file_patch_go, 0);

/**
 * @generated from extension: optional go.Options field = 7001;
 */
export const field = /*@__PURE__*/
  extDesc(file_patch_go, 1);

/**
 * @generated from extension: optional go.Options oneof = 7001;
 */
export const oneof = /*@__PURE__*/
  extDesc(file_patch_go, 2);

/**
 * @generated from extension: optional go.Options enum = 7001;
 */
export const enum$ = /*@__PURE__*/
  extDesc(file_patch_go, 3);

/**
 * @generated from extension: optional go.Options value = 7001;
 */
export const value = /*@__PURE__*/
  extDesc(file_patch_go, 4);

/**
 * @generated from extension: optional go.LintOptions lint = 7001;
 */
export const lint = /*@__PURE__*/
  extDesc(file_patch_go, 5);

